import { render, staticRenderFns } from "./HappinessFeedbacks.vue?vue&type=template&id=fe0fddc2&"
import script from "./HappinessFeedbacks.vue?vue&type=script&lang=js&"
export * from "./HappinessFeedbacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports